export const SET_FOLLOWING_PICKS = 'SET_FOLLOWING_PICKS';

export const setFollowingPicks = picks => ({
  type: SET_FOLLOWING_PICKS,
  payload: picks,
});
